import _ from 'lodash';
import { defaultSeason } from '@/utils/constants';

const initState = () => ({
  search: '',
  data: [],
  filters: {
    isActive: undefined,
    season: undefined
  },
  sort: {
    order: undefined,
    prop: undefined,
  },
  pagination: {
    total: 0,
    pageSize: 20,
    page: 1
  },
});

export default {
  namespaced: true,
  state: initState(),
  mutations: {
    reset: (state) => _.assign(state, initState()),
    // payload: {search}
    updateSearch: (state, payload) => state.search = payload.search,
    // payload: {filters}
    updateFilters: (state, payload) => state.filters = payload.filters,
    // payload: {data}
    updateData: (state, payload) => state.data = payload.data,
    // payload: {pagination}
    updatePagination: (state, payload) => _.assign(state.pagination, payload.pagination),
    // payload: {sort}
    updateSort: (state, payload) => state.sort = payload.sort,
  },
  actions: {
  },
  getters: {
    sort: (state) => state.sort,
  },
};
